module.exports = __webpack_public_path__ + "static/media/btn-google.5560b12b.svg";